import React from 'react';
import SettingsSaveButton from '../SettingsSaveButton';
import { useLanguage } from '../../../../i18n/LanguageContext';

const TulKanatSettings = React.memo(({
  extraPrices,
  setExtraPrices,
  handleSaveSettings,
  isSavingSettings,
  activeTypeTab
}) => {
  const { t } = useLanguage();
  const isTul = activeTypeTab === 'tul';

  return (
    <div className="settings-card">
      <div className="settings-card-header">
        <div className="settings-card-title">
          <i className="fas fa-cut"></i>
          <div className="settings-card-title-text">
            <h4>
              {isTul
                ? t('productList.extraPrices.tulTitle', 'Tül Pile Ek Ücret Ayarları')
                : t('productList.extraPrices.kanatTitle', 'Kanat Pile Ek Ücret Ayarları')}
            </h4>
            <span className="settings-card-subtitle">
              {isTul
                ? t('productList.extraPrices.tulSubtitle', 'Tül siparişlerinde kullanılacak pile ek ücret değerleri')
                : t('productList.extraPrices.kanatSubtitle', 'Kanat siparişlerinde kullanılacak pile ek ücret değerleri')}
            </span>
          </div>
        </div>
        <SettingsSaveButton
          onClick={() => handleSaveSettings()}
          isSaving={isSavingSettings}
        />
      </div>

      <div className="settings-fields-grid">
        <div className="form-group">
          <label>{t('pileModels.sPile', 'S Pile')}</label>
          <div className="settings-input-wrap">
            <input
              type="number"
              value={extraPrices.sPile}
              onChange={(e) => setExtraPrices(p => ({ ...p, sPile: e.target.value }))}
              placeholder="0"
            />
            <span className="settings-input-suffix">€</span>
          </div>
        </div>

        <div className="form-group">
          <label>{t('pileModels.americanTekli', 'Amerikan Tekli')}</label>
          <div className="settings-input-wrap">
            <input
              type="number"
              value={extraPrices.americanTekli || ''}
              onChange={(e) => setExtraPrices(p => ({ ...p, americanTekli: e.target.value }))}
              placeholder="0"
            />
            <span className="settings-input-suffix">€</span>
          </div>
        </div>

        <div className="form-group">
          <label>{t('pileModels.american2', "Amerikan 2'li")}</label>
          <div className="settings-input-wrap">
            <input
              type="number"
              value={extraPrices.american2}
              onChange={(e) => setExtraPrices(p => ({ ...p, american2: e.target.value }))}
              placeholder="0"
            />
            <span className="settings-input-suffix">€</span>
          </div>
        </div>

        <div className="form-group">
          <label>{t('pileModels.american3', "Amerikan 3'lü")}</label>
          <div className="settings-input-wrap">
            <input
              type="number"
              value={extraPrices.american3}
              onChange={(e) => setExtraPrices(p => ({ ...p, american3: e.target.value }))}
              placeholder="0"
            />
            <span className="settings-input-suffix">€</span>
          </div>
        </div>

        <div className="form-group">
          <label>{t('pileModels.kapsul', 'Kapsül Pile')}</label>
          <div className="settings-input-wrap">
            <input
              type="number"
              value={extraPrices.kapsul}
              onChange={(e) => setExtraPrices(p => ({ ...p, kapsul: e.target.value }))}
              placeholder="0"
            />
            <span className="settings-input-suffix">€</span>
          </div>
        </div>

        {isTul && (
          <div className="form-group">
            <label>{t('pileModels.altEtekKatlama', 'Alt Etek Katlama')}</label>
            <div className="settings-input-wrap">
              <input
                type="number"
                value={extraPrices.altEtekKatlama}
                onChange={(e) => setExtraPrices(p => ({ ...p, altEtekKatlama: e.target.value }))}
                placeholder="0"
              />
              <span className="settings-input-suffix">€</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
});

export default TulKanatSettings;
